import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import { List } from 'react-virtualized';

class PartyMaster extends Component {
    state = {
        partyMasterList:[],
        partyMasterValue: null,
        ispartyMasterLoading: true
    };
    componentDidMount(){
        this.getpartyMaster(this.props.partyMaster);

    }
    restpartyMasterFilter() {
        this.setState({
            partyMasterValue: [],
        })
    }
    getpartyMaster(party_type){
        this.setState({
            partyMasterList:[],
            ispartyMasterLoading: true,
            partyMasterValue:[]
        })
        axios.post(config.get('API_URL')+'/brandemi/get_party_list_filter/',{
               party_type: party_type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let partyMasterList = [];
            this.setState({partyMasterID:''});
            response.data.data.map((partyMaster,index) => {
                partyMasterList.push({value: partyMaster.id, label: partyMaster.party_name})
            });
            this.setState({
                partyMasterList:partyMasterList,
                ispartyMasterLoading: false
            })
        });
    }

    changepartyMaster(login_type, optionSelected){
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)

            });
        }

        this.props.onSelectPartyMaster(optionSelected, cidArray);
        this.setState({
            partyMasterValue:optionSelected,
        });

    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        return (
            <ReactMultiSelectCheckboxes name="party_master"
                isMulti
                components={{ MenuList }}
                value={this.state.partyMasterValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changepartyMaster.bind(this,'')}
                options={this.state.partyMasterList}
                placeholderButtonLabel="Select [party Master]"
                isLoading={this.state.ispartyMasterLoading}
            />
        );

    }
}
export default PartyMaster;